// extracted by mini-css-extract-plugin
export default {"box":"Features_box__S2MjZ","heading":"Features_heading__8dZbd","subHeading":"Features_subHeading__04w57","cardGroup":"Features_cardGroup__WkyBW"};